<template>
<div class="popup" v-cloak v-if="cancelShow">
    <div class="content" id="cancelShare">
        <div class="title">
            <span>{{$t('language.common.attention')}}</span>
            <div class="icon white-close dialog-close" @click="cancelShow=false"></div>
        </div>
        <div class="cancel-all-content">
            <span>{{$t('language.popup.cloudExploerPopup.cancelMyShareTask')}}</span>
        </div>
        <div class="cancel-all-footer">
            <div class="cancel-all-footer-left" >
                <button @click="cancelShow=false">{{$t('language.popup.cloudExploerPopup.cancelMyShareNot')}}</button>
            </div>
            <div class="cancel-all-footer-right" >
                <button @click="cancel()">{{$t('language.popup.cloudExploerPopup.cancelMyShareOk')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
export default {
    data: function () {
        return {
            cancelShow: false
        }
    },
    methods: {
       cancel() {
           this.$parent.cancelShare();
       }
    }
}
</script>

<style>
#cancelShare {
    width: 500px;
    /*no*/
    height: 190px;
    /*no*/
}

#cancelShare .cancel-all-content {
    width: 100%;
    /*no*/
    height: 65px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
    line-height: 20px;
    /*no*/
    margin-top: 0.3rem;
}

#cancelShare .cancel-all-footer {
    width: 100%;
    height: 48px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
}

#cancelShare .cancel-all-footer-left{
    float:left;
    width: 45%;
}

#cancelShare .cancel-all-footer-left button{
    float: right;
}

#cancelShare .cancel-all-footer-right{
    float:right;
    width: 45%;
}

#cancelShare .cancel-all-footer-right button{
    border: 1px solid #7080C6;
    background-color: #FFFFFF;
    color: #7080C6;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/cancel_share_popup.vue